<div style="height: 70px;  z-index: 10;">
    <gea-mes-header
      showLogOut="desktop"
      showMenu="both"

      showLeftIcon1="both"
      routeLeftIcon1="objectlist"
      leftIcon1Src="home"
      leftIcon1ToolTip="Home Page"
      showLeftIcon2="both",
      routeLeftIcon2="rootcausefollowup",
      leftIcon2Src="assignment",
      leftIcon1ToolTip="Root Cause Followup",

      showRightIcon1="both"
      routeRightIcon1="admin"
      rightIcon1Src="settings_applications"
      rightIcon1ToolTip="Admin Configuration"

      >
    </gea-mes-header>
</div> 
<div>
<router-outlet></router-outlet>
</div>